import { DateFormat } from "../../models/shared/formats/Date";
export const dateFormatByEncodedValue = {
  0: DateFormat.DEFAULT_LOCALE_BASED,
  64: DateFormat.MMMM_D_YYYY,
  128: DateFormat.MMM_D_YYYY,
  192: DateFormat.D_MMM_YYYY,
  256: DateFormat.YYYY_MM_DD_HYPHEN,
  320: DateFormat.YYYY_MM_DD_DOT,
  384: DateFormat.DWWWW_MMMM_D_YYYY,
  448: DateFormat.DWWW_DD_MMM_YYYY,
  512: DateFormat.DWWW_MM_DD_YYYY,
  576: DateFormat.MMMM_D,
  640: DateFormat.D_MMMM
};
export const encodedValueByDateFormat = {
  [DateFormat.MMMM_D_YYYY]: 64,
  [DateFormat.MMM_D_YYYY]: 128,
  [DateFormat.D_MMM_YYYY]: 192,
  [DateFormat.YYYY_MM_DD_HYPHEN]: 256,
  [DateFormat.YYYY_MM_DD_DOT]: 320,
  [DateFormat.DWWWW_MMMM_D_YYYY]: 384,
  [DateFormat.DWWW_DD_MMM_YYYY]: 448,
  [DateFormat.DWWW_MM_DD_YYYY]: 512,
  [DateFormat.MMMM_D]: 576,
  [DateFormat.D_MMMM]: 640,
  [DateFormat.DEFAULT_LOCALE_BASED]: 0
};

// Encode / Decode functions
export const decodeDateFormat = formatLookup => {
  return {
    dateFormat: dateFormatByEncodedValue[formatLookup.dateFormat] || DateFormat.DEFAULT_LOCALE_BASED
  };
};
export const encodeDateFormat = decodedFormat => ({
  dateFormat: encodedValueByDateFormat[decodedFormat.dateFormat]
});
//# sourceMappingURL=Date.js.map